module.exports = __webpack_public_path__ + "img/flot2.cff1dbea.svg";